<div class="component-container container">
    <div class="header-container">
        <div class="row step-number">
            <div [ngClass]="{'selected': step == 1, 'col-3': step == 3, 'col-4': step != 3, 'completed': step > 1}">
                <div class="font-mont-semi-bold">1</div>
            </div>
            <div [ngClass]="{'selected': step == 2 || step == 5, 'col-3': step == 3, 'col-4': step != 3, 'completed': step > 2 && step != 5}">
                <div class="font-mont-semi-bold">2</div>
            </div>
            <div [ngClass]="{'selected': step == 3, 'col-3': step == 3, 'col-4': step != 3, 'd-none': step != 3}">
                <div class="font-mont-semi-bold">O</div>
            </div>
            <div [ngClass]="{'selected': step == 4, 'col-3': step == 3, 'col-4': step != 3}">
                <div class="font-mont-semi-bold">3</div>
            </div>
        </div>
        <div class="row step-name">
            <div [ngClass]="{'selected': step == 1, 'col-3': step == 3, 'col-4': step != 3}">
                <div class="font-mont-semi-bold">Business</div>
                <div class="font-mont-semi-bold">Information</div>
            </div>
            <div [ngClass]="{'selected': step == 2 || step == 5, 'col-3': step == 3, 'col-4': step != 3}">
                <div class="font-mont-semi-bold">Owner</div>
                <div class="font-mont-semi-bold">Information</div>
            </div>
            <div [ngClass]="{'selected': step == 3, 'col-3': step == 3, 'col-4': step != 3, 'd-none': step != 3}">
                <div class="font-mont-semi-bold">Bank</div>
                <div class="font-mont-semi-bold">verification</div>
            </div>
            <div [ngClass]="{'selected': step == 4, 'col-3': step == 3, 'col-4': step != 3}">
                <div class="font-mont-semi-bold">Instant</div>
                <div class="font-mont-semi-bold">Result</div>
            </div>
        </div>
    </div>
    <div>
    </div>
</div>